import { useCallback, useRef, useState } from "react";

/**
 * Foco de luz que sigue al cursor dentro de un elemento.
 *
 * Devuelve las props que hay que derramar sobre el nodo. Escribe las
 * coordenadas como variables CSS en lugar de guardarlas en el estado: así el
 * movimiento del ratón no provoca un re-render por fotograma.
 *
 * El componente que lo use debe llevar la clase `spotlight`.
 *
 * @returns {{ props: object, activo: boolean }}
 */
const useSpotlight = () => {
  const ref = useRef(null);
  const [activo, setActivo] = useState(false);

  const alMover = useCallback((evento) => {
    const nodo = ref.current;
    if (!nodo) {
      return;
    }
    const caja = nodo.getBoundingClientRect();
    nodo.style.setProperty("--mx", `${evento.clientX - caja.left}px`);
    nodo.style.setProperty("--my", `${evento.clientY - caja.top}px`);
  }, []);

  const alEntrar = useCallback(() => setActivo(true), []);
  const alSalir = useCallback(() => setActivo(false), []);

  return {
    activo,
    props: {
      ref,
      onMouseMove: alMover,
      onMouseEnter: alEntrar,
      onMouseLeave: alSalir,
      "data-activo": activo ? "si" : "no",
    },
  };
};

export default useSpotlight;
